module.exports = __webpack_public_path__ + "static/img/83c666439181b2ca0b8a14072c223293.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/foot_icon1.jpg
// module id = i+kT
// module chunks = 1